import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
  Drawer,
  Button,
  Radio,
  Space,
  Row,
  Col,
  Form,
  Input,
  Select,
  DatePicker,
  message,
} from "antd";
import _ from "lodash";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import { validation } from "../../_helpers/passwordPolicy";
import { LanguageContext } from "../../context/LanguageContext";

const { Option } = Select;
const { forwardRef, useRef, useImperativeHandle } = React;

export const AnotherAdminForm = forwardRef((props, ref) => {
  console.log("props", props);
  const [form] = Form.useForm();
  const [user, SetUser] = useState({});
  const [basicDistricts, SetBasicDistricts] = useState([]);
  const [pc_cities, SetPC_cities] = useState([]);
  const [isSave, setIsSave] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);
  const [currentValueRadio, setcurrentValueRadio] = React.useState(1);
  const { language, setLanguage, t } = useContext(LanguageContext);
  useEffect(() => {
    SetUser(props.user);
  }, [props.user]);

  useEffect(() => {
    if (props.resetFrom && props.resetFrom) {
      form.setFieldsValue({ userid: "" });
      form.setFieldsValue({ passwaord: "" });
      form.setFieldsValue({ phone: "" });
      form.resetFields();
    }
  }, [props.resetFrom]);

  useImperativeHandle(ref, () => ({
    onFinish(flag) {
      setIsSave(flag);
      form.submit();
    },
  }));

  useEffect(() => {
    const { users } = props.users;
    if (props.districtData && props.districtData.length) {
      let temp = props.districtData.map((item) => {
        return {
          ...item,
          isUsed: !!_.filter(users, (o) => {
            return o.districtId === item.id;
          }).length,
        };
      });
      SetBasicDistricts(temp);
    }
    if (props.cityData && props.cityData.length) {
      let temp = props.cityData.map((item) => {
        return {
          ...item,
          isUsed: !!_.filter(users, (o) => {
            return o.cityId === item.id;
          }).length,
        };
      });
      SetPC_cities(temp);
    }
  }, [props.cityData, props.districtData, props.users]);

  useEffect(() => {
    if (props.userFormEditData) {
      setIsUpdate(true);
      let val = props.userFormEditData;
      delete val.password;
      form.setFieldsValue({
        ...val,
      });
    }
  }, [props.userFormEditData]);

  useEffect(() => {
    if (props.isUpdate) {
      setIsUpdate(true);
    } else {
      setIsUpdate(false);
    }
  }, [props.isUpdate]);

  const onFinish = (values) => {
    console.log("value", values);
    let userUpdateObj;
    if (values.password) {
      let validatPasswordPoliy = validation.cmisCheckPasswordPolicy(
        values.password,
        "",
        "",
        "",
        "",
        "",
        ["cmis"],
      );

      if (!validatPasswordPoliy[0]) {
        message.error(validatPasswordPoliy[1]);
        return false;
      }

      const hashedPassword = base64_encode(values.password);
      userUpdateObj = {
        ...values,
        password: values.password ? hashedPassword : null,
        confirm: values.password ? hashedPassword : null,
        password1: values.password,
      };
    } else {
      userUpdateObj = {
        ...values,
      };
    }
    if (isSave) {
      props.onFormFinish(userUpdateObj);
      message.success("नवीन वापरकर्ता जोडा is successfully submitted");
    } else {
      props.onFormUpdate(userUpdateObj);
      form.setFieldsValue({
        password: "",
        confirm: "",
      });
    }
  };

  return (
    <Form layout="vertical" onFinish={onFinish} form={form}>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="name"
            label={t("name")}
            rules={[
              {
                required: true,
                message: "कृपया वापरकर्त्याचे नाव प्रविष्ट करा",
              },
              // {
              //   pattern: new RegExp(/^[-_a-zA-Z0-9.]+(?:\s[-_a-zA-Z0-9.]+)*$/i),
              //   message: "Only enter valid format allowed!"
              // }
            ]}
          >
            <Input placeholder="कृपया वापरकर्त्याचे नाव प्रविष्ट करा" />
          </Form.Item>
        </Col>
        {user && user.role && user.role === "8" ? (
          <Col span={12}>
            <Form.Item
              name="cityId"
              label={t("unit")}
              rules={[
                {
                  required: true,
                  message: "Please select Unit",
                },
              ]}
            >
              <Select
                mode={props.adminUser ? "multiple" : undefined}
                placeholder="Please select Unit"
                disabled={isUpdate}
              >
                {pc_cities &&
                  pc_cities.length &&
                  pc_cities.map((res, index) => (
                    <Option key={index} value={res.id} disabled={res.isUsed}>
                      {res.City}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        ) : user && user.role && user.role === "4" ? (
          <Col span={12}>
            <Form.Item
              name="role"
              label="Role"
              rules={[{ required: true, message: "Please select role" }]}
            >
              <Select placeholder="Please select role " disabled={isUpdate}>
                <Option value="9">Crime Branch</Option>
                <Option value="10">Zone/SDPO/Sr. Officer</Option>
              </Select>
            </Form.Item>
          </Col>
        ) : null}
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="userid"
            label={t("user_id")}
            rules={[{ required: true, message: "Please Enter the User Id" }]}
          >
            <Input placeholder="Please Enter the User Id" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="phone"
            label={t("phone_no")}
            rules={[
              {
                required: true,
                message: "Please enter a valid 10-digit mobile number",
              },
              {
                pattern: /^[0-9]{10}$/,
                message: "Please enter a valid 10-digit mobile number",
              },
            ]}
          >
            <Input
              maxLength={10}
              onKeyPress={(event) => {
                if (!/^[0-9]$/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              onPaste={(event) => {
                event.preventDefault();
              }}
              placeholder="Please Enter the Mobile Number"
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            className="rememberMeCheckbox"
            name="remember"
            valuePropName="checked"
          >
            {t("password_change")}
            <Radio.Group
              onChange={(e) => {
                console.log("radio checked", e.target.value);
                setcurrentValueRadio(e.target.value);
              }}
              value={currentValueRadio}
              style={{ marginLeft: "10px" }}
            >
              <Radio value={1}>{t("yes")}</Radio>

              <Radio value={2}>{t("no")}</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      {currentValueRadio && currentValueRadio == 1 && (
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="password"
              label={t("password")}
              type="password"
              hasFeedback
              rules={[
                { required: true, message: "Please Enter the Password" },
                () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.reject();
                    }
                    if (value.length < 8) {
                      return Promise.reject("Password can't be less than 8");
                    }
                    if (value.length > 15) {
                      return Promise.reject("Password can't be more than 15");
                    }
                    if (value.search(/[a-z]/i) < 0) {
                      return Promise.reject(
                        "Password must contain at least one one lowercase letter.",
                      );
                    }
                    if (value.search(/[A-Z]/) < 0) {
                      return Promise.reject(
                        "Password must contain at least one uppercase letter.",
                      );
                    }
                    if (value.search(/[0-9]/) < 0) {
                      return Promise.reject(
                        "Password must contain at least one digit.",
                      );
                    }
                    if (value.search(/[!#$%&?]/) < 0) {
                      return Promise.reject(
                        "Password must contain at least one Special characters.",
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input.Password
                type="password"
                placeholder="Please Enter the Password"
              />
            </Form.Item>
            <Form.Item
              name="confirm"
              label={t("confirm_password")}
              dependencies={["password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please confirm your password!",
                },
                () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.reject();
                    }
                    if (value.length < 8) {
                      return Promise.reject("Password can't be less than 8");
                    }
                    if (value.length > 15) {
                      return Promise.reject("Password can't be more than 15");
                    }
                    if (value.search(/[a-z]/i) < 0) {
                      return Promise.reject(
                        "Password must contain at least one one lowercase letter.",
                      );
                    }
                    if (value.search(/[A-Z]/) < 0) {
                      return Promise.reject(
                        "Password must contain at least one uppercase letter.",
                      );
                    }
                    if (value.search(/[0-9]/) < 0) {
                      return Promise.reject(
                        "Password must contain at least one digit.",
                      );
                    }
                    if (value.search(/[!#$%&?]/) < 0) {
                      return Promise.reject(
                        "Password must contain at least one Special characters.",
                      );
                    }
                    return Promise.resolve();
                  },
                }),
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "The two passwords that you entered do not match!",
                      ),
                    );
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
          </Col>
        </Row>
      )}
      {/* <Row gutter={16}>
        <Col span={24}>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Col>
      </Row> */}
    </Form>
  );
});
